/// <reference path="../event/EventDispatcher.ts"/>

namespace com.enirva.display
{
	import EventDispatcher = com.enirva.event.EventDispatcher;

	export class Sprite extends EventDispatcher
	{
		public element: JQuery;

		public useDigit: boolean;

		public x: number;

		public y: number;

		public alpha: number;

		public scaleX: number;

		public scaleY: number;

		private _rotation: number;

		public fixedScaleX: boolean;

		public fixedScaleY: boolean;

		private currAlpha: number;

		public displayName: string;

		private _visible: boolean;

		private updateRotation: boolean;

		public ignoreAlpha:boolean;


		constructor(target: JQuery, def_props: any = null)
		{
			super();

			var tg = $(target);
			
			//各種プロパティを動かす対象
			this.element = tg;
		
			//this.setAnchor(0, 0);
		
			//アンカーが0以外の場合、ずらす分の位置
			//this.anchorDiffPos = { x : 0, y : 0 };
		
			this.useDigit = false;
		
			//モーションプロパティ
			this.x = 0;
			this.y = 0;
			this.alpha = 1;
			this.scaleX = 1;
			this.scaleY = 1;
			//this._rotation = 0;
			this._visible = true;

			this._rotation = 0;

			if (def_props != null)
			{
				for (var prop in def_props)
				{
					this[prop] = def_props[prop];
				}
			}
		
			//スケール固定にするか
			this.fixedScaleX = false;
			this.fixedScaleY = false;
			this.currAlpha = null;
		
			//display表示時のプロパティ名
			this.displayName = "block";

			this.update();
		}


		public set scale(value:number)
		{
			this.scaleX = this.scaleY = value;
		}
		public get scale():number
		{
			return this.scaleX;
		}


		public set rotation(value: number)
		{
			this._rotation = value;
			this.updateRotation = true;
		}

		public get rotation(): number
		{
			return this._rotation;
		}
	
		/*
		 * スケール時のアンカー位置セット
		 */
		public setAnchor(x: number, y: number): void
		{
			var sx = x + ((x != 0) ? "%" : "");
			var sy = y + ((y != 0) ? "%" : "");
			this.element.css("transformOrigin", sx + " " + sy);
		}
	
		/*
		 * 描画の更新
		 */
		public update(use_digit: boolean = false): void
		{
			var sc_x = (this.fixedScaleX) ? 1 : this.scaleX;
			var sc_y = (this.fixedScaleY) ? 1 : this.scaleY;
			var mtx: string;

			/*
			if (this.useDigit)
			{
				mtx = 'matrix('
					+ sc_x + ', 0, 0, '
					+ sc_y + ', ' + (this.x) + ', ' + (this.y) + ')';
			} else
			{
				mtx = 'matrix('
					+ sc_x + ', 0, 0, '
					+ sc_y + ', ' + (this.x >> 0) + ', ' + (this.y >> 0) + ')';
			}
			*/
			
			if (this.useDigit)
			{
				mtx = 'matrix3d(' + sc_x + ', 0, 0, 0,   0, ' + sc_y + ', 0, 0,  0, 0, 1, 0,          ' + (this.x) + ', ' + (this.y) + ', 0, 1)';
			} else
			{
				mtx = 'matrix3d(' + sc_x + ', 0, 0, 0,   0, ' + sc_y + ', 0, 0,  0, 0, 1, 0,          ' + (this.x >> 0) + ', ' + (this.y >> 0) + ', 0, 1)';
			}

			/*
			mtx = 'matrix3d(' + sc_x + ', 0, 0, 0,   0, ' + sc_y + ', 0, 0,  0, 0, 1, 0, 0, 0, 0, 1)';

			this.element.css({
				"left" : this.x,
				"top" : this.y
			});
			*/

			this.element.css("transform", mtx);

			if (!this.ignoreAlpha && (this.alpha != this.currAlpha))
			{
				this.element.css("opacity", this.alpha);
				this.currAlpha = this.alpha;
			}
		};


		public updateTranslateXPercent(x:number):void
		{
			const trans:string = "translateX(" + x + "%)";
			this.element.css("transform", trans);
		}


		public updateWithRot():void
		{
			this.element.css("transform", "translate(" + (this.x) + "px, " + (this.y) + "px)" + "rotateZ(" + (this._rotation) + "deg)");

		}


		public updateWithRotY():void
		{
			var sc_x = (this.fixedScaleX) ? 1 : this.scaleX;
			var sc_y = (this.fixedScaleY) ? 1 : this.scaleY;

			this.element.css("transform", 
			"translate(" + (this.x) + "px, " + (this.y) + "px)" + 
			"scale(" + sc_x + "," + sc_y + ")" +  
			"rotateY(" + (this._rotation) + "deg)");


			if (!this.ignoreAlpha && (this.alpha != this.currAlpha))
			{
				this.element.css("opacity", this.alpha);
				this.currAlpha = this.alpha;
			}
		}


		public updateMoveByPer():void
		{
			this.element.css("transform", "translate(" + (this.x) + "%, " + (this.y) + "%)");
		}
	
		/*
		 * 表示の切替
		 */
		public set visible(flag: boolean)
		{
			this._visible = flag;
			this.element.css("display", (flag) ? this.displayName : "none");
		}

		public get visible(): boolean
		{
			return this._visible;
		}


		public destroy():void
		{
			this.element.css("transform", "none");
			this.element = null;
			this.deleteEnterFrame;
		}
	}
}

